export default "__VITE_ASSET__a4b3ac66__"